const initState = [];

// 保留 Redux 的做法，直接將 initState 給 Reducer
const typeReducer = (state = initState, action) => {
  switch (action?.type) {
    case 'SELECT':
      return action.payload;
    default:
      return state;
  }
};

export default typeReducer;
